import React from "react";
import { Link } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import styles from "./thankyou.module.css";

export default function ThankYou() {
  return (
    <main id="main" className="ui-page">
      <div className="ui-container">
        <section
          className={`ui-card ui-card--lg ${styles.card}`}
          aria-labelledby="thank-you-title"
        >
          <span className={styles.successCircle} aria-hidden="true">
            <IoCheckmarkCircle size={36} />
          </span>

          <h1 id="thank-you-title">Thank you for your purchase</h1>

          <div className={styles.copy}>
            <p>Your order has been successfully processed.</p>
            <p>We appreciate your support and hope you enjoy your mRehab Starter Kit.</p>
          </div>

          <p className={styles.support}>
            If you have any questions, contact us at{" "}
            <a className="ui-link" href="mailto:support@mrehab.agency">
              support@mrehab.agency
            </a>
            .
          </p>

          <Link to="/" className="ui-btn">
            Back to home
          </Link>
        </section>
      </div>
    </main>
  );
}
